import { Observable } from 'rxjs';
import { ofType } from 'redux-observable';
import { mergeMap } from 'rxjs/operators';
import * as rosters from '@webapp/sdk/rosters';
import { Actions } from '../../actions';
import {
  DeleteRoster,
  DeleteRosterSuccess,
  DeleteRosterError,
} from '../action-creators';
import { DELETE_ROSTER } from '../actions';
import { CreateDialog } from '../../ui/action-creators';

export const deleteRosterEpic = (action$: Observable<Actions>) =>
  action$.pipe(
    ofType<Actions, DeleteRoster>(DELETE_ROSTER),
    mergeMap(async (action) => {
      return new CreateDialog(`DELETE_ROSTER.${action.rosterId}`, {
        open: true,
        title: `Confirm Delete`,
        text: `Are you sure you want to delete this roster? This can't be undone.`,
        actions: [
          { type: 'primary', label: 'No', value: false },
          { type: 'secondary', label: 'Yes', value: true },
        ],
        callback: async (result) => {
          if (!result) {
            return;
          }

          try {
            await rosters.remove(action.rosterId, action.labelId);
            return new DeleteRosterSuccess(action.rosterId);
          } catch (err) {
            return new DeleteRosterError((err as any).message);
          }
        },
      });
    })
  );
